import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import { Typography } from '@mui/material';

export default function NoticeDialog(props) {
    const { onClose, open, content } = props;

    const handleOk = () => {
        onClose();
    };

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            aria-labelledby="confirmation-dialog-title"
        >
            <DialogTitle id="alert-dialog-confirm"
                style={{ textAlign: 'center', padding: '10px', position: 'relative' }}>
                <Typography color={'primary'} style={{ fontSize: 25 }}>
                    {'Important Notice'}
                </Typography>
            </DialogTitle>
            <DialogContent >
                {content}
            </DialogContent>
            <DialogActions style={{justifyContent: 'center'}}>
                <Button onClick={handleOk} style={{backgroundColor: '#f58220', color: '#fff', width: '60%'}} color="primary">OK</Button>
            </DialogActions>
        </Dialog>
    )
}
